(function() {
    /**
     * UTILITY: The Unified Accessibility Air Traffic Controller
     * Orchestrates the Age Gate (GoodAV), Ketch Privacy Banner, and Klaviyo Popups
     */
    const runAccessibilityFixes = () => {
        
        const ageGate = document.getElementById('goodav-app');
        const ketchBanner = document.getElementById('ketch-consent-banner');
        const klaviyoForm = document.querySelector('.klaviyo-form') || document.querySelector('[id*="klaviyo"]');

        const isAgeGateActive = ageGate && window.getComputedStyle(ageGate).display !== 'none' && ageGate.offsetParent !== null;

        // Ensure timer wrap receives initial focus only once without stealing focus on slider re-renders
        const timerWrap = document.querySelector('.goodav-cart__timer-wrap');
        if (timerWrap && !timerWrap.dataset.initialFocused) {
            timerWrap.setAttribute('tabindex', '-1');
            timerWrap.focus();
            timerWrap.dataset.initialFocused = 'true';
        }

        // ========================================================
        // --- PRIORITY 1: AGE GATE TRAFFIC COP ---
        // ========================================================
        const setupAgeGateFocus = (ageGateEl) => {
            if (!ageGateEl || ageGateEl.dataset.fixed) return;

            ageGateEl.setAttribute('role', 'dialog');
            ageGateEl.setAttribute('aria-modal', 'true');
            ageGateEl.setAttribute('aria-label', 'Age Verification');
            
            const logo = ageGateEl.querySelector('.goodav-cart__timer-img');
            if (logo) logo.alt = "Deschutes";
            
            ageGateEl.setAttribute('tabindex', '-1'); 

            const yearSelect = ageGateEl.querySelector('.verification_input_year');
            if (yearSelect) yearSelect.setAttribute('aria-label', 'Select Year of Birth');
            
            ageGateEl.dataset.fixed = 'true';

            // Target the primary interactive element or fallback to the container
            const focusTarget = ageGateEl.querySelector(
                'button, select, input, [href], [tabindex]:not([tabindex="-1"])'
            ) || ageGateEl;

            // Brief delay for dynamic rendering / CSS animations to settle
            setTimeout(() => {
                focusTarget.focus();
                if (document.activeElement !== focusTarget) {
                    ageGateEl.focus();
                }
            }, 100);

            // Trap keyboard focus inside the Age Gate
            ageGateEl.addEventListener('keydown', (e) => {
                if (e.key !== 'Tab') return;
                const selectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
                const focusable = Array.from(ageGateEl.querySelectorAll(selectors)).filter(el => el.offsetParent !== null);
                if (focusable.length === 0) return;
                
                if (e.shiftKey && (document.activeElement === focusable[0] || document.activeElement === ageGateEl)) {
                    e.preventDefault(); 
                    focusable[focusable.length - 1].focus();
                } else if (!e.shiftKey && document.activeElement === focusable[focusable.length - 1]) {
                    e.preventDefault(); 
                    focusable[0].focus();
                }
            });
        };

        if (ageGate) {
            setupAgeGateFocus(ageGate);
        } else {
            // Watch the DOM dynamically until GoodAV renders
            const ageGateObserver = new MutationObserver((_, obs) => {
                const dynamicallyLoadedGate = document.getElementById('goodav-app');
                if (dynamicallyLoadedGate) {
                    setupAgeGateFocus(dynamicallyLoadedGate);
                    obs.disconnect(); // Stop watching once found and focused
                }
            });

            ageGateObserver.observe(document.documentElement || document.body, {
                childList: true,
                subtree: true
            });
        }

        // If Age Gate is active, suppress competing popups aggressively
        if (isAgeGateActive) {
            const ketchOuterWrapper = document.querySelector('[data-ketch-backdrop="true"]') || ketchBanner?.closest('[class*="ketch-fixed"]');
            if (ketchOuterWrapper) {
                ketchOuterWrapper.style.setProperty('display', 'none', 'important');
                window.ketchWasPostponed = true;
            }
            if (klaviyoForm && klaviyoForm.style.display !== 'none') {
                klaviyoForm.style.setProperty('display', 'none', 'important');
                window.klaviyoWasPostponed = true;
            }
        }

        // ========================================================
        // --- PRIORITY 2: KETCH BANNER FOCUS MANAGEMENT ---
        // ========================================================
        if (ketchBanner && !ketchBanner.dataset.fixed && !isAgeGateActive) {
            ketchBanner.setAttribute('aria-modal', 'true');
            
            // Trap keyboard focus inside the Ketch Banner
            ketchBanner.addEventListener('keydown', (e) => {
                if (e.key !== 'Tab') return;
                const selectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
                const focusable = Array.from(ketchBanner.querySelectorAll(selectors)).filter(el => el.offsetParent !== null);
                if (focusable.length === 0) return;
                
                if (e.shiftKey && (document.activeElement === focusable[0] || document.activeElement === ketchBanner)) {
                    e.preventDefault(); 
                    focusable[focusable.length - 1].focus();
                } else if (!e.shiftKey && document.activeElement === focusable[focusable.length - 1]) {
                    e.preventDefault(); 
                    focusable[0].focus();
                }
            });

            // Listen for clicks on primary privacy buttons to pass focus onwards
            const ketchButtons = ketchBanner.querySelectorAll('#ketch-banner-button-primary, #ketch-banner-button-secondary, button[name="close"]');
            ketchButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    setTimeout(() => {
                        const updatedKlaviyo = document.querySelector('.klaviyo-form') || document.querySelector('[id*="klaviyo"]');
                        if (updatedKlaviyo) {
                            updatedKlaviyo.style.removeProperty('display');
                            const firstField = updatedKlaviyo.querySelector('input, button');
                            if (firstField) {
                                firstField.focus();
                                return;
                            }
                        }
                        // Fallback to skip link if no marketing popup fires
                        const skipLink = document.querySelector('.skip-to-content-link');
                        if (skipLink) skipLink.focus();
                    }, 400); // Wait for Ketch transition animation
                });
            });

            ketchBanner.dataset.fixed = 'true';
        }

        // ========================================================
        // --- EXISTING THEME CORE FIXES (OKENDO) ---
        // ========================================================
        const okendoTitles = document.querySelectorAll('.oke-reviewContent-title[aria-level="2"]');
        okendoTitles.forEach(title => title.setAttribute('aria-level', '3'));

        if (!document.getElementById('a11y-okendo-reviews-h2')) {
            const innerOkendo = document.querySelector('[data-oke-widget]') || document.querySelector('.oke-w');
            if (innerOkendo && innerOkendo.innerHTML.trim() !== "") {
                const outermostWrapper = innerOkendo.closest('.shopify-app-block') || innerOkendo;
                const h2Element = document.createElement('h2');
                h2Element.id = 'a11y-okendo-reviews-h2';
                h2Element.classList.add('visually-hidden');
                h2Element.textContent = 'Reviews';
                outermostWrapper.insertAdjacentElement('beforebegin', h2Element);
            }
        }

        // ========================================================
        // --- PRIORITY 3: GLOBAL KLAVIYO CLOSURE OBSERVER ---
        // ========================================================
        if (!window.klaviyoFocusObserverAttached) {
            window.addEventListener("klaviyoForms", function(e) {
                if (e.detail.type === 'open' && isAgeGateActive) {
                    const dynamicForm = document.querySelector('.klaviyo-form') || document.querySelector('[id*="klaviyo"]');
                    if (dynamicForm) dynamicForm.style.setProperty('display', 'none', 'important');
                    window.klaviyoWasPostponed = true;
                    return;
                }

                if (e.detail.type === 'close' || e.detail.type === 'submit') {
                    setTimeout(() => {
                        const centerX = window.innerWidth / 2;
                        const centerY = window.innerHeight / 2;
                        let targetElement = document.elementFromPoint(centerX, centerY);
                        
                        if (targetElement) {
                            if (targetElement.closest('[id*="klaviyo"]') || targetElement.id === 'goodav-app' || targetElement.closest('#ketch-banner')) {
                                targetElement = document.querySelector('.skip-to-content-link') || document.body;
                            } else {
                                const meaningfulAnchor = targetElement.closest('section, article, main, h1, h2, h3, p, a, button, [role="button"]');
                                if (meaningfulAnchor) targetElement = meaningfulAnchor;
                            }
                            if (!targetElement.hasAttribute('tabindex')) targetElement.setAttribute('tabindex', '-1');
                            targetElement.focus({ preventScroll: true }); 
                        }
                    }, 150);
                }
            });
            window.klaviyoFocusObserverAttached = true;
        }
    };

    // ========================================================
    // --- MUTATION OBSERVER WATERFALL ROUTER ---
    // ========================================================
    const observer = new MutationObserver((mutations) => {
        let ageGateClosed = false;

        for (const mutation of mutations) {
            for (const removedNode of mutation.removedNodes) {
                if (removedNode.id === 'goodav-app') ageGateClosed = true;
            }
            if (mutation.type === 'attributes' && mutation.target.id === 'goodav-app') {
                const style = window.getComputedStyle(mutation.target);
                if (style.display === 'none' || style.visibility === 'hidden' || mutation.target.classList.contains('hide')) {
                    ageGateClosed = true;
                }
            }
        }

        if (ageGateClosed) {
            let attempts = 0;
            const tryRestoreFocus = () => {
                const ageGate = document.getElementById('goodav-app');
                const klaviyoForm = document.querySelector('.klaviyo-form') || document.querySelector('[id*="klaviyo"]');
                
                const isGateGone = !ageGate || window.getComputedStyle(ageGate).display === 'none' || ageGate.offsetParent === null;

                if (isGateGone) {
                    // Transition 1: Ketch Privacy Banner
                    const ketchOuterWrapper = document.querySelector('[data-ketch-backdrop="true"]') || document.getElementById('ketch-consent-banner')?.closest('[class*="ketch-fixed"]');
                    const realKetchBanner = document.getElementById('ketch-consent-banner');
                    
                    if (realKetchBanner && ketchOuterWrapper) {
                        ketchOuterWrapper.style.removeProperty('display');
                        
                        let ketchAttempts = 0;
                        const forceKetchFocus = () => {
                            const primaryKetchBtn = document.getElementById('ketch-banner-button-primary');
                            if (primaryKetchBtn && primaryKetchBtn.offsetParent !== null) {
                                primaryKetchBtn.focus();
                                window.ketchWasPostponed = false;
                            } else if (ketchAttempts < 15) {
                                ketchAttempts++;
                                setTimeout(forceKetchFocus, 100);
                            }
                        };
                        forceKetchFocus();
                        return;
                    }

                    // Transition 2: Klaviyo
                    if (window.klaviyoWasPostponed && klaviyoForm) {
                        klaviyoForm.style.removeProperty('display');
                        const firstKlaviyoElement = klaviyoForm.querySelector('input, button, [role="button"]');
                        if (firstKlaviyoElement) {
                            firstKlaviyoElement.focus();
                            window.klaviyoWasPostponed = false;
                            return;
                        }
                    }

                    // Fallback to Skip Link
                    const skipLink = document.querySelector('.skip-to-content-link');
                    if (skipLink) {
                        skipLink.focus();
                        if (document.activeElement === skipLink) return;
                    }
                }

                attempts++;
                if (attempts < 20) setTimeout(tryRestoreFocus, 100);
            };
            tryRestoreFocus();
        }

        observer.disconnect(); 
        runAccessibilityFixes();
        startObserving();
    });

    const startObserving = () => {
        if (document.body) {
            observer.observe(document.body, { 
                childList: true, 
                subtree: true,
                attributes: true, 
                attributeFilter: ['aria-level', 'class', 'style'] 
            });
        }
    };

    if (document.body) startObserving();
    else window.addEventListener('DOMContentLoaded', startObserving);

    runAccessibilityFixes();
})();